import type {AlertColor} from "@mui/material/Alert";
import {makeAutoObservable} from "mobx";

export type Msg = {msg: string, severity: AlertColor};

export class SnackbarController {
    snackBarVisible = false
    snackBarContent: Msg | null = null
    timeout: NodeJS.Timeout | null = null

    constructor() {
        makeAutoObservable(this);
    }

    setContent(msg: Msg) {
        this.snackBarContent = msg;
        this.snackBarVisible = true;
    }

    hide() {
        this.snackBarVisible = false;
        this.setTimeout(0)
    }

    setTimeout(ms: number): (() => void) | void {
        if (this.timeout !== null) {
            clearTimeout(this.timeout)
            this.timeout = null;
        }
        if (ms > 0) {
            this.timeout = setTimeout(() => this.hide(), ms)
        }
    }
}
